import { Globe, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { LANGS, getLang, applyLang } from "@/i18n";
import api from "@/lib/api";

export const LanguageSwitcher = ({ compact = false }) => {
  const current = getLang();
  const pick = async (code) => {
    if (localStorage.getItem("token")) await api.patch("/auth/preferences", { lang: code }).catch(() => {});
    applyLang(code);
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size={compact ? "icon" : "sm"} className="text-muted-foreground gap-1.5" data-testid="language-switcher" translate="no">
          <Globe className="w-[18px] h-[18px]" />
          {!compact && <span className="uppercase text-xs font-semibold">{current}</span>}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44" translate="no">
        {LANGS.map((l) => (
          <DropdownMenuItem key={l.code} onClick={() => pick(l.code)} data-testid={`language-option-${l.code}`}>
            <span className="w-7 text-xs font-bold uppercase text-muted-foreground">{l.code}</span>
            <span className="flex-1">{l.label}</span>
            {l.code === current && <Check className="w-4 h-4 text-primary" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;
